import React from 'react';
import configuration from '../configuration';

const signupErrorHandler = (message) => {
  if (message && message.includes('UsernameExistsException')) alert('Diese E-Mail-Adresse wird bereits benutzt.');
  if (message && message.includes('InvalidParameterException')) alert('Die Daten, die du eingegeben hast, können so leider nicht akzeptiert werden.');
  if (message && message.includes('InvalidPasswordException')) alert('Es hat noch nicht funktioniert. Bitte gib ein Passwort an, das die Standards erfüllt:\n' + configuration.passwordPolicies.join('\n'));
};

export default {
  signupErrorHandler
}
;
